import LazyImageI from '../types.ts';

const imageLoad: LazyImageI['imageLoad'] = function () {
    const { loadCallback } = this.props;

    this.setState({ isReady: true }, loadCallback);
};

export default imageLoad;
